import type { IUsuario } from "../../../modelos/Usuario/entidades/IUsuario";
import type { IProyecto } from "../../../modelos/Proyectos/entidades/IProyecto";
import dayjs from "dayjs";

export interface IFiltroMonitor {
    UsuarioId: number | null;
    Fecha: string | null;
}

export interface IEntidadesRegistroMonitor {
    Tecnicos: IUsuario[];
}

export interface IMonitorMarker {
    id: string | number;
    latitud: number;
    longitud: number;
    titulo: string;
    orden: number;
    tipoPunto?: string;
    fecha?: string;
    tecnico?: string;
    esInicioSesion?: boolean;
    servicioId?: number;
    estadoTareaId?: number;
    estadoTareaNombre?: string;
}

export interface IFiltroMonitorVistaProps {
    filtro: IFiltroMonitor;
    consultarTrazabilidad: () => void;
    entidadesRegistro: IEntidadesRegistroMonitor;
    manejarCambioFiltroMonitor: (campo: keyof IFiltroMonitor, valor: any) => void;
    limpiarFiltros: () => void;
    cargando: boolean;
}

export interface IMonitorVistaProps {
    filtro: IFiltroMonitor;
    consultarTrazabilidad: () => void;
    entidadesRegistro: IEntidadesRegistroMonitor;
    manejarCambioFiltroMonitor: (campo: keyof IFiltroMonitor, valor: any) => void;
    limpiarFiltros: () => void;
    markers: IMonitorMarker[];
    cargando: boolean;
    proyectos: IProyecto[];
}

export const estadoInicialFiltroMonitor: IFiltroMonitor = {
    UsuarioId: null,
    Fecha: dayjs().format("YYYY-MM-DD")
};
